import React from 'react';
import Button from '../components/Common/Button';
import { Link } from 'react-router-dom';

import Parlexeffect from '../components/Core/Home/Parlexeffect';
import BlogAndLatestNews from '../components/Core/Home/BlogAndLatestNews';

// Local Images
import plc from '../data/Measuring/PLC.jpg';
import HMI from '../data/Measuring/HMI.jpeg';
import SCADA from '../data/Measuring/Scada.png';
import Web from '../data/Measuring/it.jpg';

// Online Images
const AppImg =
  'https://tse3.mm.bing.net/th/id/OIP.uXec9F7WiVGiBlbi1lYjcgHaEd?pid=Api&P=0&h=180';

const CloudImg =
  'https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=crop&w=600&q=80';

const placeholderImg =
  'https://via.placeholder.com/800x450?text=Image+not+available';

// ⭐ FIXED: Removed unnecessary escape characters (NO WARNINGS)
const makeKey = (str) =>
  str.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');

const Home = () => {
  const industrialServices = [
    {
      title: 'PLC Automation',
      img: plc,
      desc:
        'High-performance PLC solutions engineered for reliable, real-time industrial control across complex systems.',
    },
    {
      title: 'HMI Panels',
      img: HMI,
      desc:
        'Intuitive HMI interfaces designed to improve operator experience, streamline monitoring, and enable smart control.',
    },
    {
      title: 'SCADA Systems',
      img: SCADA,
      desc:
        'Enterprise-grade SCADA solutions for centralized monitoring, data acquisition, and remote industrial supervision.',
    },
  ];

  const itServices = [
    {
      title: 'Web Development',
      img: Web,
      desc:
        'Custom-built websites, dashboards, and digital platforms optimized for speed, scalability, and modern UI/UX.',
    },
    {
      title: 'App Development',
      img: AppImg,
      desc:
        'Cross-platform mobile and desktop apps engineered with the latest technologies and seamless performance.',
    },
    {
      title: 'Cloud Solutions',
      img: CloudImg,
      desc:
        'Secure and scalable cloud deployment, automation, and modernization on AWS, Azure & Google Cloud.',
    },
  ];

  // Fail-safe image fallback
  const handleImgError = (e) => {
    e.target.src = placeholderImg;
  };

  return (
    <main className="flex flex-col items-center justify-center min-h-screen bg-slate-50 text-slate-900">
      {/* ================= HERO SECTION ================= */}
      <header className="w-full bg-gradient-to-br from-slate-800 to-slate-950 text-white">
        <div className="max-w-7xl mx-auto px-4 py-16 md:py-24 flex flex-col md:flex-row items-center gap-10">
          <div className="flex-1 text-center md:text-left">
            <p className="font-semibold text-sm md:text-lg">
              Welcome to MD CONTROL & IT SOLUTIONS
            </p>

            <h1 className="mt-4 font-extrabold leading-tight text-3xl sm:text-4xl md:text-5xl lg:text-6xl">
              Engineering Future-Ready Automation & IT Systems
            </h1>

            <p className="mt-6 text-slate-200 text-base md:text-lg max-w-2xl">
              Delivering advanced automation, intelligent control systems, and powerful IT solutions
              designed for industries that demand reliability, precision, and innovation.
            </p>

            <div className="mt-6 flex flex-wrap gap-3 justify-center md:justify-start">
              <Button text={true} firstTag="Get Started" />
              <Link to="/about">
                <Button text={false} secondTag="Learn More →" />
              </Link>
            </div>
          </div>

          <div className="flex-1 flex justify-center">
            <img
              src="1st.png"
              alt="Automation Hero"
              className="w-full max-w-md rounded-xl shadow-xl object-cover"
              onError={handleImgError}
              loading="lazy"
            />
          </div>
        </div>
      </header>

      {/* ================= WHY CHOOSE US ================= */}
      <section className="w-full max-w-6xl px-4 py-10 sm:py-14">
        <h2 className="text-blue-700 font-semibold text-xl text-center md:text-left">
          Why Choose Us
        </h2>

        <p className="mt-3 text-2xl sm:text-3xl font-bold text-slate-800 text-center md:text-left">
          Trusted Expertise. Future-Driven Technology.
        </p>

        <p className="mt-4 text-slate-600 max-w-2xl text-center md:text-left">
          We combine engineering excellence with modern development to deliver scalable, reliable,
          and secure solutions across industries.
        </p>

        <div className="mt-6 flex items-center gap-4 justify-center md:justify-start">
          <div className="flex -space-x-2">
            <img
              className="h-12 w-12 rounded-full ring-2 ring-white"
              src="https://images.unsplash.com/photo-1491528323818-fdd1faba62cc"
              loading="lazy"
              onError={handleImgError}
            />
            <img
              className="h-12 w-12 rounded-full ring-2 ring-white"
              src="https://images.unsplash.com/photo-1550525811-e5869dd03032"
              loading="lazy"
              onError={handleImgError}
            />
            <img
              className="h-12 w-12 rounded-full ring-2 ring-white"
              src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e"
              loading="lazy"
              onError={handleImgError}
            />
          </div>

          <div className="h-12 w-12 bg-slate-700 text-white rounded-full flex items-center justify-center ring-2 ring-white font-bold">
            5K+
          </div>

          <p className="text-slate-600 text-sm">Satisfied clients across industrial & IT sectors</p>
        </div>
      </section>

      {/* ================= SERVICES SECTION ================= */}
      <section className="w-full bg-gradient-to-br from-slate-800 to-slate-950 text-white py-12">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center">
            <p className="text-2xl font-semibold">Our Services</p>
            <h3 className="mt-3 text-3xl sm:text-4xl font-extrabold">
              Comprehensive Automation & IT Solutions
            </h3>
            <p className="mt-4 text-slate-300 max-w-2xl mx-auto">
              From industrial controls to modern digital systems—our services elevate your
              operations and improve efficiency.
            </p>

            <div className="mt-8 flex justify-center gap-4 flex-wrap">
              <Link to="/automation">
                <button className="px-5 py-3 bg-blue-600 hover:bg-blue-700 rounded-lg font-bold shadow-md">
                  Explore Automation →
                </button>
              </Link>
              <Link to="/it-solution">
                <button className="px-5 py-3 bg-indigo-600 hover:bg-indigo-700 rounded-lg font-bold shadow-md">
                  Explore IT Solutions →
                </button>
              </Link>
            </div>
          </div>

          <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-10">
            {/* Industrial Automation */}
            <div className="rounded-2xl p-6 bg-slate-900/60 backdrop-blur shadow-xl">
              <h4 className="text-2xl font-bold">Industrial Automation</h4>
              <p className="text-slate-300 mt-2">
                Advanced control systems engineered for precision, safety & efficiency.
              </p>

              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-6">
                {industrialServices.map((svc) => {
                  const key = makeKey(svc.title);
                  return (
                    <div
                      key={key}
                      className="bg-slate-700/30 rounded-lg p-4 flex flex-col gap-3"
                    >
                      <img
                        src={svc.img}
                        alt={svc.title}
                        className="w-full h-40 object-cover rounded-md"
                        onError={handleImgError}
                      />
                      <h5 className="text-lg font-semibold">{svc.title}</h5>
                      <p className="text-sm text-slate-300">{svc.desc}</p>

                      <Link to="/automation" className="mt-auto">
                        <Button text={false} secondTag="View Details →" />
                      </Link>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* IT Services */}
            <div className="rounded-2xl p-6 bg-slate-900/60 backdrop-blur shadow-xl">
              <h4 className="text-2xl font-bold">IT & Web Solutions</h4>
              <p className="text-slate-300 mt-2">
                Modern digital solutions tailored for businesses of every scale.
              </p>

              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-6">
                {itServices.map((svc) => {
                  const key = makeKey(svc.title);
                  return (
                    <div
                      key={key}
                      className="bg-slate-700/30 rounded-lg p-4 flex flex-col gap-3"
                    >
                      <img
                        src={svc.img}
                        alt={svc.title}
                        className="w-full h-40 object-cover rounded-md"
                        onError={handleImgError}
                      />
                      <h5 className="text-lg font-semibold">{svc.title}</h5>
                      <p className="text-sm text-slate-300">{svc.desc}</p>

                      <Link to="/it-solution" className="mt-auto">
                        <Button text={false} secondTag="Learn More →" />
                      </Link>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Parlexeffect />
      <BlogAndLatestNews />
    </main>
  );
};

export default Home;
